export enum WidgetLayout {
  DEFAULT = 'default',
  SIDE = 'side',
}
